import { makeStyleSelector } from "@client/content/modules/Button";

export const makeButtonStyleSelector = makeStyleSelector;
